import { createTracker as createTrackerAuth } from 'usage-tracker';
import { createTracker as createTrackerAnonymous } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import events from '../../events.yaml';
import { getIsStaticPublicUrl } from './urls';
import { withSessionReplay } from 'usage-tracker-session-replay';
import { isLocalProdApp } from 'academy-common-lib/utils/url';
export const createTracker = getIsStaticPublicUrl() ? createTrackerAnonymous : createTrackerAuth;
const tracker = createTracker(Object.assign({
  events
}, getIsStaticPublicUrl() && {
  properties: {
    email: null,
    hubId: null,
    lang: null,
    deviceId: makeUuid()
  }
}));
const trackerWithSessionReplay = withSessionReplay(tracker);
export const usageTracker = isLocalProdApp() ? tracker : Object.assign(Object.create(Object.getPrototypeOf(trackerWithSessionReplay)), trackerWithSessionReplay);